import type {
  InboxWorkflowCellComponent,
  InboxWorkflowFlowConfig,
} from "@kontextwerk/control-web-frame/inbox-workflow/contract"
import {
  buildFlowSteps,
  withHelp,
  workflowDefinition,
  workflowStep,
} from "../../_shared/_logic/registry-composition"
import { inboxWorkflowHelpDialogIds } from "../../_shared/_logic/help-dialog-ids"
import {
  createReplaceWrongRecipientStep,
  replaceWrongRecipientCells,
} from "./steps/01_replace_wrong_recipient"
import {
  createWrongRecipientSourceCleanupStep,
  wrongRecipientSourceCleanupCells,
} from "./steps/02_source_cleanup"

export const wrongRecipientCells: Record<string, InboxWorkflowCellComponent> = {
  ...replaceWrongRecipientCells,
  ...wrongRecipientSourceCleanupCells,
}

export const wrongRecipientReplacementFlow: InboxWorkflowFlowConfig = {
  definition: workflowDefinition({
    flowKey: "wrong_recipient_replacement",
    label: "Falschen Ansprechpartner korrigieren",
    subjectPolicy: "REQUIRED",
    requirements: ["REPLACE_OR_REMOVE_WRONG_RECIPIENT_CUSTOMER", "UPDATE_SOURCE_CONTACT_DATA"],
    steps: [
      workflowStep({
        stepKey: "replace_wrong_recipient",
        label: "Falsche Zuordnung korrigieren",
        componentKey: "wrong_recipient_replacement.replace_wrong_recipient",
        requirements: ["REPLACE_OR_REMOVE_WRONG_RECIPIENT_CUSTOMER"],
        outputKey: "wrong_recipient_replacement",
      }),
      workflowStep({
        stepKey: "source_cleanup",
        label: "Im Kehrbezirksprogramm nachtragen",
        componentKey: "shared.source_cleanup",
        requirements: ["UPDATE_SOURCE_CONTACT_DATA"],
        outputKey: "source_cleanup",
      }),
    ],
  }),
  steps: buildFlowSteps({
    replace_wrong_recipient: withHelp(
      createReplaceWrongRecipientStep(),
      inboxWorkflowHelpDialogIds.wrongRecipientReplacement,
    ),
    source_cleanup: withHelp(
      createWrongRecipientSourceCleanupStep(),
      inboxWorkflowHelpDialogIds.wrongRecipientSourceCleanup,
    ),
  }),
}
